// Field numbers from the real tablet, posted back to the build machine. Tuning used to mean asking the player to read
// figures off the screen; now the device just says what it measured. Only the build machine's server (serve.mjs)
// listens on /report, so only the home addresses (tailnet, LAN, localhost) send anything; a public copy sends nothing.
import { perf, track, tuning } from './pose.ts';
import { device } from './device.ts';

export const reporting = /\.ts\.net$|^localhost$|^127\.|^192\.168\.|^10\.|^100\./.test(location.hostname);

export function report(kind: string, data: unknown = {}) {
  if (!reporting) return;
  const round = (o: object) => Object.fromEntries(Object.entries(o).map(([k, v]) => [k, typeof v === 'number' ? +v.toFixed(1) : v]));
  const body = JSON.stringify({ kind, at: new Date().toISOString(), ua: navigator.userAgent, screen: [innerWidth, innerHeight, devicePixelRatio], device, tracker: { ...round(perf), ...round(track), model: tuning.model, sharp: tuning.sharp, fastCam: tuning.fastCam, direct: tuning.direct }, data });
  try { void fetch('/report', { method: 'POST', body, keepalive: body.length < 60000 }).catch(() => {}); } catch { /* offline: nothing to do */ }
}
